

module dg.objects {
    interface ILookupScope extends ng.IScope {
        form: any;
        propLookupData: dg.domain.model.DomainModelRefInfo[];
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        fixLookupDataObjectByModel(propLookupDataArray: dg.domain.model.DomainModelRefInfo[]): void;
        fixSelectedData(propLookupDataArray: dg.domain.model.DomainModelRefInfo[]): void;
        tagTransform(tagName: string): dg.domain.model.Tag;
        tagSelected($item, $model): void;
        domainObject: dg.domain.IDomainObject;
        dataLoaded: boolean;
        refreshData(): void;
    }

    export interface ILookupAttributes extends ng.IAttributes {
        ngModel: string;
        dgQueryItems: string;
        multiple: string;
        tagging: string;
        placeholder: string;
    }

    function lookup(actionService: dg.actions.ActionService, dgGuid: dgUtils.DgGuid): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel'],
            templateUrl: (tElement, tAttrs: ILookupAttributes) => {
                return '/digmo/src/objects/properties/lookup/lookup' + (angular.isDefined(tAttrs.multiple) ? '-multi' : '') + '.html'
            },
            compile: (tElement, tAttrs: ILookupAttributes) => {

                var uiSelectChoicesElement = angular.element('ui-select-choices, *[ui-select-choices]', tElement);
                var queryItemsExpression = uiSelectChoicesElement.attr('repeat').replace('dgQueryItems', tAttrs.dgQueryItems);
                uiSelectChoicesElement.attr('repeat', queryItemsExpression);

                if (angular.isDefined(tAttrs.placeholder)) {
                    angular.element('ui-select-match, *[ui-select-match]', tElement).attr('placeholder', tAttrs.placeholder);
                }

                var uiSelectElement = angular.element('ui-select, *[ui-select]', tElement);
                uiSelectElement.attr('ng-model', tAttrs.ngModel);

                if (angular.isDefined(tAttrs.tagging)) {
                    uiSelectElement.attr('tagging', 'tagTransform');
                    var taggingLable = angular.isDefined(tAttrs.multiple) ? '(new)' : 'false';
                    uiSelectElement.attr('tagging-label', taggingLable);
                    //uiSelectElement.attr('tagging-label', '(new)');
                    uiSelectElement.attr('tagging-tokens', ',|ENTER');
                    //uiSelectElement.attr('tagging-tokens', "[',','ENTER']");
                    uiSelectElement.attr('on-select', 'tagSelected($item, $model)');
                }

                return (scope: ILookupScope, element, attrs: ILookupAttributes, ctrls) => {
                    var ngModelCtrl: ng.INgModelController = ctrls[0];

                    //TODO: this function has to be called with refresh-on-active="true" if they make this feature available
                    scope.refreshData = () => {
                        if (angular.isDefined(scope.propMeta.links.lookupResult) && !scope.propMeta.readOnly) {

                            actionService.getQueryResult(scope.propMeta.links.lookupResult.href).then((lookupData: any) => {
                                scope.propLookupData = <domain.model.DomainModelRefInfo[]>lookupData.items;
                                scope.dataLoaded = true;
                            });
                        }
                    };

                    scope.tagTransform = (tagName) => {

                        if (!tagName) {
                            return null; 
                        }

                        var existingTags = scope.propLookupData.filter((item) => {
                            return item.displayValue.toLowerCase() == tagName.toLowerCase()
                        });
                       
                        if (existingTags.length > 0) {
                            return existingTags[0];
                        }
                        //HACK: to fix
                        return null;
                        //return <dg.domain.model.ITag>{
                        //    id: dgGuid.generateGUID(),
                        //    displayValue: tagName,
                        //    isNew: true
                        //};
                    };

                    scope.tagSelected = ($item: dg.domain.model.Tag, $model) => {
                        if ($item && $item.isNew) {
                            //create tag
                            //disable command save button until new tag response is resolved
                            //TODO: Fix - scope.dgDomainTypeMetaCtrl.disableAllActions();
                            actionService.getAction(scope.propMeta.links.add.href).then(command => {
                                let createTagCommand = <dg.domain.model.CreateTagCommand>command;
                                createTagCommand.name = $item.displayValue;
                                //TODO: uncomment and fix
                                actionService.executeCommand(createTagCommand).then(() => {
                                    var newItem = <dg.domain.model.Tag>{
                                        id: createTagCommand.aggregateId,
                                        displayValue: $item.displayValue
                                    };
                                    scope.propLookupData.push(newItem);
                                    var selectedTags = ngModelCtrl.$modelValue;
                                    if (angular.isArray(selectedTags)) {
                                        for (var i = 0; i < selectedTags.length; ++i) {
                                            if (selectedTags[i] == $item.id) {
                                                selectedTags.splice(i, 1, newItem.id);
                                                break;
                                            }
                                        }
                                    } else {
                                        ngModelCtrl.$setViewValue(newItem.id);
                                    }
                                });

                                //enable command save button after tag is created
                                //TODO: Fix - scope.dgDomainTypeMetaCtrl.enableAllActions();
                            });

                        }
                    };

                    //validations and ng-model
                    scope.form[scope.propMeta.id] = ngModelCtrl;
                    var stopNgModelWatch = scope.$watch(attrs.ngModel, (value: any, oldValue: any) => {
                        if ((angular.isArray(value) && angular.isArray(oldValue) && value.length != oldValue.length) ||
                            (!angular.isArray(value) && value != oldValue) ) {
                            scope.form[scope.propMeta.id].$pristine = false;
                            scope.form[scope.propMeta.id].$dirty = true;
                            //stopNgModelWatch();
                        }
                    });
                };
            }
        };
    }
    //lookup.$inject = [
    //    'DgMetadataService',
    //    'DgGuid'
    //];

    function dgRefreshUiSelect() {
        return {
            restrict: 'A',
            require: ['uiSelect', 'ngModel'],
            link: (scope: ILookupScope, element, attrs: ILookupAttributes, ctrls) => {
                var selectCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1];

                //fix ngModel object equality on load
                scope.fixLookupDataObjectByModel = (propLookupDataArray: dg.domain.model.DomainModelRefInfo[]) => {
                    if ((selectCtrl.selected != null && !angular.isArray(selectCtrl.selected)) ||
                        (angular.isArray(selectCtrl.selected) && selectCtrl.selected.length > 0)) {

                        for (var index = 0; index < propLookupDataArray.length; ++index) {
                            var object = propLookupDataArray[index];
                            if (angular.isArray(selectCtrl.selected)) {
                                for (var modelIndex = 0; modelIndex < selectCtrl.selected.length; ++modelIndex) {
                                    var modelObj = <dg.domain.model.DomainModelRefInfo>selectCtrl.selected[modelIndex];
                                    if (object.id == modelObj.id) {
                                        propLookupDataArray[index] = modelObj;
                                        break;
                                    }
                                }
                            } else {
                                if (selectCtrl.selected != null && object.id == selectCtrl.selected.id) {
                                    propLookupDataArray[index] = selectCtrl.selected;
                                    break;
                                }
                            }
                        }
                    }
                };
                //scope.fixSelectedData = (propLookupDataArray: dg.domain.model.DomainModelRefInfo[]) => {
                //    if ((selectCtrl.selected != null && !angular.isArray(selectCtrl.selected)) ||
                //        (angular.isArray(selectCtrl.selected) && selectCtrl.selected.length > 0)) {

                //        for (var index = 0; index < propLookupDataArray.length; ++index) {
                //            var lookupObject = propLookupDataArray[index];
                //            if (angular.isArray(selectCtrl.selected)) {
                //                for (var modelIndex = 0; modelIndex < selectCtrl.selected.length; ++modelIndex) {
                //                    var modelObj = <dg.domain.model.DomainModelRefInfo>selectCtrl.selected[modelIndex];
                //                    if (lookupObject.id == modelObj.id) {
                //                        selectCtrl.selected[modelIndex] = lookupObject;
                //                        break;
                //                    }
                //                }
                //            } else {
                //                if (selectCtrl.selected != null && lookupObject.id == selectCtrl.selected.id) {
                //                    propLookupDataArray[index] = selectCtrl.selected;
                //                    break;
                //                }
                //            }
                //        }
                //    }
                //};
                //scope.$watchCollection(attrs.ngModel,(value, oldValue) => {
                //    if (angular.isDefined(scope.propLookupData) && !!value && !!oldValue &&
                //        ((!angular.isArray(value) && value.id == oldValue.id) || (angular.isArray(value) && value.length > 0 && value.length == oldValue.length))) {
                //        //this is data reload update lookupdata object equality
                //        scope.fixLookupDataObjectByModel(scope.propLookupData);
                //    }
                //});

                //required when propData is loaded after ngModel data
                scope.$watch('propLookupData', function (propLookupDataArray: any, propLookupDataArrayOld) {
                    if (angular.isDefined(propLookupDataArray)) {
                        scope.fixLookupDataObjectByModel(propLookupDataArray);
                    }
                });


                //chage [propName]Ref property when selection changes
                scope.$watchCollection(attrs.ngModel,(value, oldValue) => {
                    //if (angular.isDefined(scope.domainObject[scope.propMeta.id + 'Ref'])) {
                        scope.domainObject[scope.propMeta.id] = selectCtrl.selected;
                    //ss}
                });
            }
        };
    }

    angular.module('dg.objects')
        //.directive('lookup', lookup)
        //.directive('dgRefreshUiSelect', dgRefreshUiSelect);
}